import { useEffect, useRef } from 'react';
import { AgreementContainer } from '../../pages/onboarding/onboarding.styled';

interface AgreementProps {
  id: string;
  onScroll: (e: any) => void;
  content: string;
  onBottomReached: (id: string) => void;
}

export function Agreement(props: AgreementProps): JSX.Element {
  const { id, onScroll, content, onBottomReached } = props;
  const ref = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (ref.current?.scrollHeight === ref.current?.clientHeight) {
      onBottomReached(id);
    }
  }, [ref]);

  return (
    <AgreementContainer id={id}>
      <div
        id={id}
        ref={ref}
        onScroll={onScroll}
        className='myDivToPrint text-2xl descriptionOutput '
        dangerouslySetInnerHTML={{
          __html: content,
        }}></div>
    </AgreementContainer>
  );
}
